<template>
  <div>
    <template v-if="display==1">
      <h5>企画・特集管理</h5>
      <label for="status" class="col-form-label">ステータス:</label>
      <select class="my-2" v-model="searchForm.status">
        <option v-for="(item, index) in status" :value="item.no" :key="`status-${item.no}`">{{ item.name }}</option>
      </select>
      <a class="btn btn-info col-md-1 my-2" href="javascript:void(0);" @click="searchArticle">検索</a>
      <hr>
      <div>
        <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="newArticle"> ＋ 新しい企画・特集を作る</a>
      </div>
      <div class="py-3 article_contents">
        <div v-for="(article, index) in allGetArticles">
          <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-header">
                  <div class="row">
                      <span class="col-md-8 text-left">{{ article['title'] }}</span>
                      <span class="col-md-4 text-right">
                        <a href="javascript:void(0);" @click="editArticle(article['id'])" class="btn btn-primary btn-sm">編集</a>
                        <template v-if="String(article['status'])=='0'">
                          <a href="javascript:void(0);" @click="statusChange(article['id'], 1)" class="btn btn-secondary btn-sm">公開停止</a>
                        </template>
                        <template v-if="String(article['status'])=='1'">
                          <a href="javascript:void(0);" @click="statusChange(article['id'], 0)" class="btn btn-primary btn-sm">公開する</a>
                        </template>
                        <a href="javascript:void(0);" @click="jumpArticleDetail(article['id'])" class="btn btn-primary btn-sm">記事一覧へ</a>
                      </span>
                  </div>
              </div>
              <div class="card-body">
                  <div class="row px-3">
                      <div class="col-md-3 pl-1 pr-1 m-0">
                        <img class="" :src="article['main_image']" style="width: 100%;height: auto;">
                      </div>
                      <div class="card col-md-9 pl-0 pr-0 m-0">
                          <div class="card-body">
                              <p class="card-text">ライター名:　{{ article['writer_name'] }}</p>
                              <p class="card-text">公開記事数:　{{ article['article_detail_count'] }}</p>
                              <p class="card-text">スローガン:　{{ article['slogan'] }}</p>
                              <p class="card-text">登録日:　{{ date_only_format(article['created_at']) }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="page" v-show="allGetArticles.length>0">
          <vuejs-paginate
            :page-count="allGetPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="allClickCallback"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </vuejs-paginate>
        </div>
      </div>
    </template>

    <template v-if="display==2">
      <h5>企画・特集を作る</h5>
      <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="backArticle">戻る</a>
      <hr>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">Titleタグ  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="articleForm.meta_title" class="required form-control" rows="2" v-bind:class="{ error_input: articleForm.errors.meta_title.length > 0 }"></textarea>
              <div v-if="articleForm.errors.meta_title.length > 0">
                <div class="error-text" v-for="(item, index) in articleForm.errors.meta_title" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">Descriptionタグ  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="articleForm.meta_description" class="required form-control" rows="3" maxlength="" v-bind:class="{ error_input: articleForm.errors.meta_description.length > 0 }"></textarea>
              <div v-if="articleForm.errors.meta_description.length > 0">
                <div class="error-text" v-for="(item, index) in articleForm.errors.meta_description" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <hr>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">タイトル  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="articleForm.title" class="required form-control" rows="2" v-bind:class="{ error_input: articleForm.errors.title.length > 0 }"></textarea>
              <div v-if="articleForm.errors.title.length > 0">
                <div class="error-text" v-for="(item, index) in articleForm.errors.title" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">スローガン  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="articleForm.slogan" class="required form-control" rows="3" maxlength="" v-bind:class="{ error_input: articleForm.errors.slogan.length > 0 }"></textarea>
              <div v-if="articleForm.errors.slogan.length > 0">
                <div class="error-text" v-for="(item, index) in articleForm.errors.slogan" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">ライター名  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="articleForm.writer_name" class="form-control" rows="1" v-bind:class="{ error_input: articleForm.errors.writer_name.length > 0 }"></textarea>
              <div v-if="articleForm.errors.writer_name.length > 0">
                <div class="error-text" v-for="(item, index) in articleForm.errors.writer_name" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 px-1">
            <label for="" class="col-sm-12 control-label">画像 推奨サイズ(600px X 800px)<span class="required_mark">必須</span></label>
            <div class="row mt-2 mb-2 mx-0">
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2" v-bind:class="{ error_input: articleForm.errors.main_image.length > 0 }">
                      <img :src="articleForm.main_image" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage1">選択</label>
                    <input type="file" style="display: none" ref="input1" @change="onImageChange1"/>
                </div>
            </div>
            <div v-if="articleForm.errors.main_image.length > 0">
              <div class="error-text" v-for="(item, index) in articleForm.errors.main_image" :key="index">{{ item }}</div>
            </div>
        </div>
      </div>
      <div class="form-group">
          <div class="b100 col-sm-12">
            <template v-if="mode==1 || mode==3">
              <button type="button" class="bs100 btn btn-primary" @click="article_form_submit(1)">公開する</button>
              <button type="button" class="mt-3 bs100 btn btn-primary" @click="article_form_submit(0)">非公開で登録する</button>
              <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
            </template>
            <template v-if="mode==2">
              <button type="button" class="bs100 btn btn-primary" @click="article_form_submit(2)">更新する</button>
            </template>
          </div>
      </div>
    </template>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const status = [
      {"no":"0","name":"公開"},
      {"no":"1","name":"未公開"},
    ];
    return {
      status,
      display: 1,
      imageSet: false,
			all_articles: [],
			all_parPage: 5,
			all_currentPage: 1,
      mode: null, // 1:登録 2:更新
      btn_type: null,

      searchForm: {
        status: 0,
      },

      isError: false,
      articleForm: {
        errors: {
          title: [],
          slogan: [],
          writer_name: [],
          main_image: [],
          meta_title: [],
          meta_description: [],
        },
        title: null,
        slogan: null,
        writer_name: null,
        main_image: null,
        meta_title: null,
        meta_description: null,

        status: null,
        id: null,
      },
    }
  },
  methods: {
	  jumpArticleDetail: function(id){
      window.open('/mypage?page=11&articles_id='+id, '_blank')
      return false;
      // this.$router.push({path: '/mypage', query: {articles_id: String(id), page: 11}});
	  },
    // 企画・特集
    searchArticle() {
      this.get_articles();
      return false;
    },
    newArticle() {
      this.display = 2;
      this.mode = 1;
      this.imageSet = false;
      return false;
    },
    backArticle() {
      this.display = 1;
      this.articleFormReset();
      this.get_articles();
      return false;
    },
    editArticle(id) {
      this.get_article(id);
      this.display = 2;
      this.mode = 2;
      this.imageSet = true;
      return false;
    },
    statusChange(id, status) {
      let msg = "";
      if ( status == 0 ) {
        msg = "公開してもよろしいですか?";
      } else if ( status == 1 ) {
        msg = "公開停止にしてもよろしいですか?";
      }
      if(confirm(msg)) {
        this.articleForm.id = id;
        this.articleForm.status = status;
        this.exec_update_article_status();
      }
      return false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onImageChange1(e) { this.onImageChange(1, e); },
    onImageChange(target, e) {
      const images = e.target.files || e.dataTransfer.files
      this.getBase64(images[0]).then(image => {
        const originalImg = new Image()
        originalImg.src = image
        originalImg.onload = () => {
          const resizedCanvas = this.createResizedCanvasElement(originalImg)
          const resizedBase64 = resizedCanvas.toDataURL(images[0].type)
          if ( target == 1 ) { this.articleForm.main_image = resizedBase64 }
          this.imageSet = true;
        }
      }).catch(error =>
        alert('画像処理に失敗しました。再度画像を選択してください。')
      )
    },
    uploadImage1() { this.$refs.input1.click(); },
    createResizedCanvasElement(originalImg) {
      const originalImgWidth = originalImg.width
      const orifinalImgHeight = originalImg.height
      const [resizedWidth, resizedHeight] = this.resizeWidthAndHeight(originalImgWidth, orifinalImgHeight)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = resizedWidth
      canvas.height = resizedHeight
      ctx.drawImage(originalImg, 0, 0, resizedWidth, resizedHeight)
      return canvas
    },
    resizeWidthAndHeight(width, height) {
      const MAX_WIDTH = 800
      const MAX_HEIGHT = 600
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      return [width, height]
    },    
    article_form_submit(btn_type) {
      this.btn_type = btn_type;
      // 0:公開 1:非公開
      if ( btn_type == 0 ) {
        this.articleForm.status = 1;
      } else if ( btn_type == 1 || btn_type == 2 ) {
        this.articleForm.status = 0;
      }
			this.isError = false;
			this.articleForm.errors.title = [];
			this.articleForm.errors.slogan = [];
			this.articleForm.errors.writer_name = [];
			this.articleForm.errors.main_image = [];
			this.articleForm.errors.meta_title = [];
			this.articleForm.errors.meta_description = [];
      if (!this.imageSet) {
        this.articleForm.errors.main_image.push('画像を選択してください');
        this.isError = true;
      }
			if (!this.articleForm.meta_title) {
				this.articleForm.errors.meta_title.push('Titleタグが入力されていません');
				this.isError = true;
			}
			if (!this.articleForm.meta_description) {
				this.articleForm.errors.meta_description.push('Descriptionタグが入力されていません');
				this.isError = true;
			}
			if (!this.articleForm.title) {
				this.articleForm.errors.title.push('タイトルが入力されていません');
				this.isError = true;
			}
			if (!this.articleForm.slogan) {
				this.articleForm.errors.slogan.push('スローガンが入力されていません');
				this.isError = true;
			}
			if (!this.articleForm.writer_name) {
				this.articleForm.errors.writer_name.push('ライター名が入力されていません');
				this.isError = true;
      }
			if (!this.isError) {
        if ( this.mode == 1 ) {
  				this.exec_new_article();
        } else if ( this.mode == 2 ) {
  				this.exec_update_article();
        }
			} else {
				window.scrollTo({
					top: 0,
				});
			}
      return false;
    },
    // 商品登録処理
    async exec_new_article() {
      this.$store.dispatch('article/new_article', {
        article: this.articleForm,
      }).then(res => {
        console.log(res);
        if ( this.btn_type == 0 ) {
          alert('一時保存が完了しました。');
        } else if ( this.btn_type == 1 ) {
          alert('登録が完了しました。');
        } else if ( this.btn_type == 2 ) {
          alert('更新が完了しました。');
        }
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.articleFormReset();
        this.backArticle();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // 商品更新処理
    async exec_update_article() {
      this.$store.dispatch('article/upd_article', {
        article: this.articleForm,
      }).then(res => {
        console.log(res);
        if ( this.btn_type == 0 ) {
          alert('一時保存が完了しました。');
        } else if ( this.btn_type == 1 ) {
          alert('登録が完了しました。');
        } else if ( this.btn_type == 2 ) {
          alert('更新が完了しました。');
        }
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.articleFormReset();
        this.backArticle();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // ステータス更新処理
    async exec_update_article_status() {
      this.$store.dispatch('article/upd_article_status', {
        article: this.articleForm,
      }).then(res => {
        console.log(res);
        alert('ステータス更新が完了しました。')
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.articleFormReset();
        this.get_articles();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
		async get_articles() {
			this.$store.dispatch('article/get_articles', {
        status: this.searchForm.status,
        // sort: this.searchForm.sort,
      }).then(res => {
				console.log(res);
				this.all_articles = res.data.articles;
				// this.articleCount = this.all_articles.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		async get_article(id) {
			this.$store.dispatch('article/get_article', {
        id: id,
      }).then(res => {
				console.log(res);
				let g_article = res.data.article;
        this.articleForm.status = g_article.status;
        this.articleForm.title = g_article.title;
        this.articleForm.slogan = g_article.slogan;
        this.articleForm.writer_name = g_article.writer_name;
        this.articleForm.main_image = g_article.main_image;
        this.articleForm.meta_title = g_article.meta_title;
        this.articleForm.meta_description = g_article.meta_description;
        this.articleForm.id = g_article.id;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
    articleFormReset: function () {
      this.articleForm.title = null;
      this.articleForm.slogan = null;
      this.articleForm.writer_name = null;
      this.articleForm.main_image = null;
      this.articleForm.id = null;
      this.articleForm.status = null;
      this.articleForm.meta_title = null;
      this.articleForm.meta_description = null;
    },
  },
	computed: {
		allGetArticles: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.all_articles.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.all_articles.length / this.all_parPage);
		},
	},
  created() {
    this.get_articles();
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/article.vue